import { useMutation, useQueryClient } from '@tanstack/react-query';
import { provisionAndGrantPartner } from '../services/partners';
import { partnerQueryKeys } from './query-keys';

export const useGrantPartnerMutation = (options = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) => {
      const result = await provisionAndGrantPartner(payload);
      if (!result.success) {
        throw new Error(result.message || 'Failed to add partner');
      }
      return result;
    },
    onSuccess: async (...args) => {
      await queryClient.invalidateQueries({ queryKey: partnerQueryKeys.all });
      options.onSuccess?.(...args);
    },
    ...options,
  });
};
